import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
// Styles
import './IoButton.css';

const IoButton = ({
    onClick,
    name,
    value,
    show,
    buttonText,
    children,
    classOverride,
    styleOverride,
    stateValue,
    disabled,
    forceUserClick,
    type,
    formId
}) => {

    // isClicked is used with forceUserClick to force the user to make a selection
    // even when having a default value, forceUserClick needs to be pass dowen as
    // false when on edit state
    const [isClicked, setIsClicked] = useState(false);

    const handleClick = (event = null) => {
        setIsClicked(true);
        !formId && event && event.preventDefault();
        if (onClick) {
            onClick(event, name, value);
        }
    }

    // Used for Button Set
    const match         = isNaN(stateValue) ? value == stateValue : parseInt(value) == stateValue;
    const checkClicked  = (forceUserClick && isClicked) || !forceUserClick;
    const buttonClass   = `${((match && checkClicked)
        ? `${SG.BG_PRIMARY} ${SG.BTN_PRIMARY} ${SG.C_3} ${SG.HOVER_1}`
        : `${SG.BTN_SECONDARY} ${SG.HOVER_3} ${SG.BD_PRIMARY}`)} ${SG.BTN} ${SG.F_BUTTON}`;

    const content = children ? children : buttonText;

    return (
        <Fragment>
            {show && !formId &&
                <button
                    className={`${buttonClass} ${classOverride} ${disabled && 'isDisabled'}`}
                    style={styleOverride}
                    onClick={handleClick}
                    type={type}
                >
                    {content}
                </button>
            }
            {show && formId &&
                <button
                    className={`${buttonClass} ${classOverride} ${disabled && 'isDisabled'}`}
                    style={styleOverride}
                    type={type}
                    form={formId}
                    value="Submit"
                    onClick={handleClick}
                >
                    {content}
                </button>
            }
        </Fragment>
    );
}

IoButton.defaultProps = {
    classOverride: '',
    show: true,
    disabled: false,
    value: '',
    name: '',
    stateValue: '',
    styleOverride: {},
    forceUserClick: false,
    type: 'button',
    formId: '',
    onClick: null
};

IoButton.propTypes = {
    // Button Label
    buttonText: PropTypes.string,
    // Function to call onClick
    onClick: PropTypes.func,
    // Name
    name: PropTypes.string,
    // Value
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    // State value is used for btn set
    stateValue: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    // Show or not the button
    show: PropTypes.bool,
    // Is desiabled
    disabled: PropTypes.bool,
    // Display block or inline
    styleOverride: PropTypes.object,
    // Any custom CSS class
    classOverride: PropTypes.string,
    // Forces user to make a selection when in New flow
    // Needs to be false when on Edit flow
    forceUserClick: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool
    ]),
    // Type submit
    type: PropTypes.oneOf([
        'submit',
        'reset',
        'button'
    ]),
    formId: PropTypes.string
};

export default IoButton;
